import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import MapIcon from "@mui/icons-material/Map";
import ScoreCard from "../ScoreCard";

const TrypAccordion = ({
  date,
  time,
  length,
  distance,
  scores,
  events,
  isDisabled,
}) => {
  const accStyle = {
    height: isDisabled && "33%",
    mb: "0",
    "& .Mui-expanded": {
      background: "lightgrey",
    },
    "&.Mui-disabled": {
      backgroundColor: "#FFF",
    },
    "& > div.Mui-disabled": {
      opacity: 1,
    },
  };
  const summaryStyle = {
    "& .MuiAccordionSummary-content": {
      flexDirection: "column",
      width: "100%",
    },
    "& .Mui-expanded": {
      m: "12px 0px",
      background: "lightgrey",
    },
  };
  const titleStyle = {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    "& p": {
      fontWeight: 600,
    },
  };
  const subtitleStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    p: "6px 0 4px",
  };
  const catStyle = {
    display: "flex",
    alignItems: "center",
    color: "darkslategrey",
  };
  const iconStyle = {
    width: "1rem",
    height: "1rem",
    mr: "0.5rem",
    color: "darkslategrey",
    transform: "scale(1)",
  };
  const detailsStyle = {
    height: isDisabled ? "0" : "100%",
    p: "0",
    borderTop: "solid 1px grey",
    borderBottom: "solid 1px black",
    background: "lightgrey",
  };
  const scoresStyle = {
    display: "flex",
    flexFlow: "row wrap",
    p: "8px 16px",
  };
  const eventsStyle = {
    display: "flex",
    justifyContent: "space-between",
    p: "8px 16px",
    borderBottom: "solid 1px grey",
  };
  const listStyle = {
    display: "flex",
    width: "64%",
  };
  const severityStyle = {
    display: "flex",
    width: "32%",
  };

  const icons = {
    speed: "speed",
    brake: "brake",
    left: "left",
    right: "cornering",
    accel: "acceleration",
    phone: "phone",
  };

  const EventList = () => {
    const eventList = {
      speed: 0,
      brake: 0,
      left: 0,
      right: 0,
      accel: 0,
      phone: 0,
    };
    const severities = {
      mild: 0,
      moderate: 0,
      severe: 0,
    };

    // Populate eventList and severities with data
    events.forEach((event) => {
      eventList[event.type.toLowerCase()]++;
      switch (true) {
        case event.severity < 2:
          severities.mild++;
          break;
        case event.severity < 4:
          severities.moderate++;
          break;
        default:
          severities.severe++;
      }
    });

    return (
      <Box sx={eventsStyle}>
        <Box sx={listStyle}>
          {Object.keys(eventList).map((key) => (
            <ScoreCard
              event={true}
              value={eventList[key]}
              icon={icons[key]}
              key={key}
            />
          ))}
        </Box>
        <Box sx={severityStyle}>
          {Object.keys(severities).map((key) => (
            <ScoreCard
              event={true}
              value={severities[key]}
              icon={key}
              key={key}
            />
          ))}
        </Box>
      </Box>
    );
  };

  return (
    <Accordion disableGutters={true} sx={accStyle} disabled={isDisabled}>
      <AccordionSummary sx={summaryStyle}>
        <Box sx={titleStyle}>
          <Typography color="black">{date}</Typography>
          <Typography color="black">{time}</Typography>
        </Box>
        <Box sx={subtitleStyle}>
          <Box display="flex">
            <ScoreCard value={scores.total} icon="total" />
            <ScoreCard value={scores.handling} icon="handling" />
            <ScoreCard value={scores.focus} icon="focus" />
          </Box>
          <Box>
            <Typography sx={catStyle}>
              <AccessTimeIcon sx={iconStyle} /> {length}
            </Typography>
            <Typography sx={catStyle}>
              <MapIcon sx={iconStyle} /> {distance}
            </Typography>
          </Box>
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={detailsStyle}>
        {!isDisabled ? (
          <>
            <EventList />
            <Box sx={scoresStyle}>
              {Object.keys(scores).map((key, index) => (
                <ScoreCard key={index} value={scores[key]} icon={key} />
              ))}
            </Box>
          </>
        ) : null}
      </AccordionDetails>
    </Accordion>
  );
};

export default TrypAccordion;
